export default __webpack_public_path__ + "static/media/edit.f892bd4b.svg";